export enum FLAGS {
  ENABLE_MONETIZATION_MANAGEMENT_UI = 'enable-monetization-management-ui',
  ENABLE_WEBINAR_MANAGEMENT_UI = 'enable-webinar-management-ui',
  ENABLE_WEBINAR_TEMPLATES_MANAGEMENT_UI = 'enable-webinar-templates-management-ui',
  ENABLE_SETTINGS_MANAGEMENT_UI = 'enable-settings-management-ui',
  ENABLE_NEW_WEBINAR_CREATION_FLOW = 'enable-new-webinar-creation-flow',
  ENABLE_RECORDING_MANAGEMENT_UI = 'enable-recording-management-ui',
  ENABLE_PARTICIPANT_INVOICES_UI = 'enable-participant-invoices-ui',
  ENABLE_AUTOMATION_MANAGEMENT_UI = 'enable-automation-management-ui',
  ENABLE_PARTICIPANTS_UI = 'enable-participants-ui',
}
